/**
 * Type
 */
export enum CommercialType {
  TV = "TV",
  Radio = "Radio",
  Digital = "Digital",
  Print = "Print",
  OOH = "OOH",
  Social = "Social",
  BTS = "BTS",
  Other = "Other",
}
